import { PageHeader } from "@/components/ui/PageHeader";
import { useSidebarAnimation } from "@/hooks/use-sidebar-animation";
import { useSidebarStore } from "@/stores/sidebar-store";
import { MenuOpenOutlined, MenuOutlined } from "@mui/icons-material";
import {
  ButtonBase,
  Container,
  AppBar as MuiAppBar,
  Slide,
  Toolbar,
  useScrollTrigger,
} from "@mui/material";

export function AppBar() {
  const { open, toggleOpen, disabled } = useSidebarStore();
  const sidebarAnimationSx = useSidebarAnimation();

  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      <MuiAppBar
        elevation={0}
        sx={{
          backgroundColor: "background.default",
          borderBottom: "1px solid",
          borderColor: "divider",
          color: "text.primary",
        }}
      >
        <Container maxWidth={false} sx={sidebarAnimationSx}>
          <Toolbar variant="dense" disableGutters sx={{ gap: 2 }}>
            <ButtonBase
              disabled={disabled}
              sx={{
                p: 0.5,
                "&:hover": {
                  backgroundColor: "action.hover",
                  borderRadius: 1,
                },
              }}
            >
              {open && !disabled ? (
                <MenuOpenOutlined fontSize="large" onClick={toggleOpen} />
              ) : (
                <MenuOutlined fontSize="large" onClick={toggleOpen} />
              )}
            </ButtonBase>
            <PageHeader />
          </Toolbar>
        </Container>
      </MuiAppBar>
    </Slide>
  );
}
